import React from "react";
import { Link } from "react-router-dom";

const CatalogHeader = ({
    itemCount,
    isBitrix,
    search,
    onSearchChange,
    isSmartSearching,
    priceBasis,
    onPriceBasisChange,
    region,
    manualRegion,
    onManualRegionChange,
    availableRegions,
}) => (
    <>
        <div className="pc-topbar">
            <div className="pc-topbar-inner">
                <div>
                    <h1 className="pc-title">Каталог товаров</h1>
                    <div className="pc-subtitle">
                        {itemCount} позиций в базе{isBitrix ? "" : " · открыто вне Bitrix24"}
                    </div>
                </div>
                <Link className="pc-back-link" to="/">← Вернуться к калькулятору</Link>
            </div>
        </div>

        <div className="pc-header">
            <div className="pc-toolbar">
                <input
                    className="pc-search"
                    type="text"
                    placeholder="Поиск по номенклатуре или производителю..."
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
                {isSmartSearching && <span className="pc-search-status">Поиск...</span>}

                <div className="pc-segmented">
                    <button className={priceBasis === "cash" ? "active" : ""} onClick={() => onPriceBasisChange("cash")}>Нал</button>
                    <button className={priceBasis === "noncash" ? "active" : ""} onClick={() => onPriceBasisChange("noncash")}>Безнал</button>
                </div>

                {region ? (
                    <div className="pc-region-badge">Регион: {region}</div>
                ) : (
                    <div className="pc-region-unknown">
                        Регион не определён
                        <select
                            className="pc-region-select"
                            value={manualRegion || ""}
                            onChange={(e) => onManualRegionChange(e.target.value || null)}
                        >
                            <option value="">выбрать...</option>
                            {availableRegions.map((r) => (
                                <option key={r} value={r}>{r}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
        </div>
    </>
);

export default CatalogHeader;
